export type { UpsellSource } from '@/lib/analytics/events/upsell';

export function getUpgradeUrl(source: string): string {
  return `/app/upgrade?source=${encodeURIComponent(source)}`;
}
